import { render } from "./BasketItem.vue?vue&type=template&id=ada7bb4a"
import script from "./BasketItem.vue?vue&type=script&lang=js"
export * from "./BasketItem.vue?vue&type=script&lang=js"

import "./BasketItem.vue?vue&type=style&index=0&id=ada7bb4a&lang=scss"

import exportComponent from "/codebuild/output/src4027941633/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__